var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m58.966 135.57 10.164-10.165c5.933-5.932 15.55-5.932 21.483 0l27.234 27.235 71.54-71.54c5.932-5.932 15.55-5.932 21.482 0l10.165 10.165c5.932 5.932 5.932 15.55 0 21.481L139.33 194.45c-11.865 11.865-31.1 11.865-42.966 0l-37.398-37.398c-5.932-5.932-5.932-15.55 0-21.482"
})));
export default SvgCheck;